/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface GitLabStatusSync
 */
export interface GitLabStatusSync {
    /**
     * 
     * @type {Array<string>}
     * @memberof GitLabStatusSync
     */
    closedStatuses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GitLabStatusSync
     */
    closedStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof GitLabStatusSync
     */
    openStatus?: string;
}

export function GitLabStatusSyncFromJSON(json: any): GitLabStatusSync {
    return {
        'closedStatuses': !exists(json, 'closedStatuses') ? undefined : json['closedStatuses'],
        'closedStatus': !exists(json, 'closedStatus') ? undefined : json['closedStatus'],
        'openStatus': !exists(json, 'openStatus') ? undefined : json['openStatus'],
    };
}

export function GitLabStatusSyncToJSON(value?: GitLabStatusSync): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'closedStatuses': value.closedStatuses,
        'closedStatus': value.closedStatus,
        'openStatus': value.openStatus,
    };
}


